// A 20-over match produces a few hundred revisions. Anything beyond this in a
// single step is a spoofed or corrupt packet: caching it as "latest" would make
// every legitimate update from the real scorer compare as older, permanently
// freezing the recorder's broadcast sync.
export const MAX_REVISION_JUMP = 50000;
// persist() bumps _stateRevision a handful of times per delivery; even a full
// tournament day on a single match stays far below this. Anything above it is
// not a real match state.
export const MAX_REVISION = 1_000_000;

export function isNewerPeerSnapshot(current, incoming) {
  if (!incoming) return false;
  const incomingRevision = Number(incoming.revision) || 0;
  if (!Number.isInteger(incomingRevision) || incomingRevision < 0) return false;
  if (incomingRevision > MAX_REVISION) return false;
  if (!current) return true;
  const currentRevision = Number(current.revision) || 0;
  if (incomingRevision - currentRevision > MAX_REVISION_JUMP) return false;
  if (incomingRevision !== currentRevision) return incomingRevision > currentRevision;
  return (Number(incoming.sentAt) || 0) > (Number(current.sentAt) || 0);
}

